import { Checkbox } from '@/components_deprecated'
import styled from 'styled-components'

export const StyledFilterCheckbox = styled(Checkbox)`
  input:disabled + .--checkbox-box {
    border-color: ${props => props.theme.colors.gray8};
    color: ${props => props.theme.colors.gray8};
    opacity: 0.55;
    filter: grayscale(1);
  }
`

export const FilterOptionsStack = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  & > * + * {
    margin-top: 0.3rem;
  }
`
